const STORAGE_KEY = 'advancewell_user'

export type StoredUser = {
    user_id: string
    name: string
    email: string
    is_admin: boolean
    organization_id: string | null
}

export function getStoredUser(): StoredUser | null {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    try {
        return JSON.parse(raw) as StoredUser
    } catch {
        return null
    }
}

export function setStoredUser(user: StoredUser): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(user))
}

export function clearStoredUser(): void {
    localStorage.removeItem(STORAGE_KEY)
}
